// import moment from 'moment';
import { helpers as sharedHelpers } from '../../../../Shared/helpers';

const productHelpers = {

	productFormat(product) {
		// make sure the product is set up correctly
		if(!product.settings) product.settings = {};

		if(!product.redemption_settings) product.redemption_settings = {};
		return product;
	},

	customFields(origin, value) {
		if(origin === 'merchant-portal') {
			return {
				bw_add_to_future_passes: {
					field_code: 'bw_add_to_future_passes',
					value
				}
			}
		}
		else {
			return {};
		}
	},

	getTemplate(product, template, validIds = []) {
		let found = null;
		if(product.template_id === template.id) {
			found = template;
		}
		else {
			found = (template.children || []).find(x => x.id === product.template_id);
		}
		if(found && validIds.length > 0 && !validIds.includes(found.id)) {
			found = null;
		}
		return found;
	},

	getGeneratedName: (selectedTemplate, product) => {
		switch (selectedTemplate?.code) {
			case 'bw_basic_coupon':
				return product.settings.coupon_text;
			case 'bw_buy_one_get_one_free':
				return `Buy One ${product.settings.coupon_bogo_item || '___'}, Get One ${product.settings.coupon_bogo_item || '___'} Free`;
			case 'bw_buy_one_get_one_50_off':
				return `Buy One ${product.settings.coupon_bogo_item || '___'}, Get One ${product.settings.coupon_bogo_item || '___'} 50% Off`;
			case 'bw_dollar_off':
				let amountOff = +product.settings.coupon_amount_off || 0;
				amountOff = amountOff % 1 !== 0 ? amountOff.toFixed(2) : amountOff;
				return `$${amountOff || '___'} Off ${product.settings.coupon_discount_item || ''}`;
			case 'bw_percent_off':
				return `${product.settings.coupon_percent_off || '___'}% Off ${product.settings.coupon_discount_item || ''}`;
			case 'bw_free_with_purchase_of':
				return `Free ${product.settings.coupon_free_item || '___'} With Purchase Of ${product.settings.coupon_purchase_item || '___'}`;
			case 'bw_free_coupon':
				return `Free ${product.settings.coupon_free_service_item || '___'}`;
			case 'bw_free_food_beverage':
				return `Free ${product.settings.tasting_free_item || '___'}`;
			case 'bw_special_item_food_beverage':
				return `${product.settings.special_item_name || 'Special Item'}`;
			case 'bw_tasting_flight':
			case 'bw_tasting_flight_non_remittance':
				return `${product.settings.tasting_flight_type || '___'} Tasting Flight`;
			case 'bw_dollar_voucher':
				let amount = +product.settings.tasting_voucher_amount || 0;
				amount = amount % 1 !== 0 ? amount.toFixed(2) : amount;
				return `$${amount || '___'} Voucher`;
			case 'bw_prix_fixe_menu':
				return `Prix Fixe Menu`;
			case 'bw_special_item':
				return `Special Item`;
			default:
				return 'Product Name';
		}
	},

	checkGeneratedName: ($set, selectedTemplate, product, generatedName, defaultName) => {
		if((product.name && product.name.toLowerCase() === defaultName) ||
				(product.name.toLowerCase() === generatedName?.toLowerCase()) ||
				(!product.name && !defaultName)) {
			return true;
		}
		switch (selectedTemplate?.code) {
			case 'bw_basic_coupon': {
				$set(product.settings, 'coupon_text', product.name);
				return true;
			}
			case 'bw_buy_one_get_one_free': {
				const match = product.name?.match(/^Buy One (.*), Get One \1 Free$/);
				if(match) {
					$set(product.settings, 'coupon_bogo_item', match[1]);
				}
				else {
					$set(product.settings, 'coupon_bogo_item', '');
				}
				return match != null;
			}
			case 'bw_buy_one_get_one_50_off': {
				const match = product.name?.match(/^Buy One (.*), Get One \1 50% Off$/);
				if(match) {
					$set(product.settings, 'coupon_bogo_item', match[1]);
				}
				else {
					$set(product.settings, 'coupon_bogo_item', '');
				}
				return match != null;

			}
			case 'bw_dollar_off': {
				let amountOff = +product.settings.coupon_amount_off || 0;
				amountOff = amountOff % 1 !== 0 ? amountOff.toFixed(2) : amountOff;
				const match = product.name?.match(/^\$(\d+(\.\d+)?) Off (.*)/);
				if(match) {
					$set(product.settings, 'coupon_amount_off', match[1]);
					$set(product.settings, 'coupon_discount_item', match[3]);
				}
				else {
					$set(product.settings, 'coupon_amount_off', '');
					$set(product.settings, 'coupon_discount_item', '');
				}
				return match != null;
			}
			case 'bw_percent_off': {
				const match = product.name?.match(/^(\d+(\.\d+)?)% Off (.*)/);
				if(match) {
					$set(product.settings, 'coupon_percent_off', match[1]);
					$set(product.settings, 'coupon_discount_item', match[3]);
				}
				else {
					$set(product.settings, 'coupon_percent_off', '');
					$set(product.settings, 'coupon_discount_item', '');
				}
				return match != null;
			}
			case 'bw_free_with_purchase_of': {
				const match = product.name?.match(/^Free (.*) With Purchase Of (.*)/);
				if(match) {
					$set(product.settings, 'coupon_free_item', match[1]);
					$set(product.settings, 'coupon_purchase_item', match[2]);
				}
				else {
					$set(product.settings, 'coupon_free_item', '');
					$set(product.settings, 'coupon_purchase_item', '');
				}
				return match != null;
			}
			case 'bw_free_coupon': {
				const match = product.name?.match(/^Free (.*)/);
				if(match) {
					$set(product.settings, 'coupon_free_service_item', match[1]);
				}
				else {
					$set(product.settings, 'coupon_free_service_item', '');
				}
				return match != null;
			}
			case 'bw_free_food_beverage': {
				const match = product.name?.match(/^Free (.*)/);
				if(match) {
					$set(product.settings, 'tasting_free_item', match[1]);
				}
				else {
					$set(product.settings, 'tasting_free_item', '');
				}
				return match != null;
			}
			case 'bw_special_item_food_beverage': {
				$set(product.settings, 'special_item_name', product.name);
				return true;
			}
			case 'bw_tasting_flight':
			case 'bw_tasting_flight_non_remittance': {
				const match = product.name?.match(/(.*) Tasting Flight$/);
				if(match) {
					$set(product.settings, 'tasting_flight_type', match[1]);
				}
				else {
					$set(product.settings, 'tasting_flight_type', '');
				}
				return match != null;
			}
			case 'bw_dollar_voucher': {
				let amount = +product.settings.tasting_voucher_amount || 0;
				amount = amount % 1 !== 0 ? amount.toFixed(2) : amount;
				const match = product.name?.match(/^\$(\d+(\.\d+)?) Voucher$/);
				if(match) {
					$set(product.settings, 'tasting_voucher_amount', match[1]);
				}
				else {
					$set(product.settings, 'tasting_voucher_amount', '');
				}
				return match != null;
			}
			case 'bw_prix_fixe_menu': {
				const match = product.name?.match(/^Prix Fixe Menu$/);
				if(!match) {
					$set(product, 'name', 'Prix Fixe Menu');
				}
				return match != null;
			}
			case 'bw_special_item': {
				const match = product.name?.match(/^Special Item$/);
				if(!match) {
					$set(product, 'name', 'Special Item');
				}
				return match != null;
			}
			default: {
				return false;
			}
		}
	},

	acceptPreview: (product, productName, preview, returnUrl) => {
		// Closes the modal
		preview.url = undefined;

		window.EventBus.$emit('system-messages', [
			{
				message: productName + ' ' + (product.id
						? 'updated'
						: 'created') + ' - redirecting now...',
				messageType: 'success',
				showOverlay: true
			}
		]);
		window.userpilot?.track(`product_submitted`, { product_id: product.id });
		setTimeout(() => {
			window.location = returnUrl;
		}, 2000);
	},

	saveChanges: (isSaving, partner, venue, product, preview) => {
		isSaving = true;

		// if the product is in progress, or no status, move to form submitted. This assumes all required fields are filled in.
		if(!product.status || product.status == 19) // in progress
			product.status = 9; // submitted

		const ending = product.id ? `/${product.id}` : '';
		const url = partner
				? `/partner-portal/${partner.id}/products/save-product${ending}`
				: `/merchant-portal/${venue.id}/products/main/save-product${ending}`
		;

		axios.put(url, product)
				.then(response => {
					preview.url = response.data.preview_url;
					product.id = response.data.product.id;
					product.tickets = response.data.product.tickets;
				})
				.catch(error => {
					isSaving = false;
					const errorMsg = error?.response?.data?.message ?? error.message;
					window.EventBus.$emit('system-messages', [
						{ message: errorMsg, messageType: 'error' }
					]);
				});
	},

	getReturnUrl: (returnUrl, partner, venue) => {
		const routeString = sessionStorage.returnRoute;
		if (routeString) {
			sessionStorage.removeItem('returnRoute');
			return routeString;
		}

		return returnUrl || (partner
				? `/partner-portal/${partner.id}/products/list-products`
				: `/merchant-portal/${venue.id}/products/main/list-products`);
	}


};

const checkinHelpers = {

	getValidationRules: (data) => ({
		template_id: [v => !!v || 'You must choose a checkin template.'],
		name: [v => !!v || 'Name is required.'],
		radius: [v => v >= 0.25 || 'You must select a radius greater than 0.25 miles.'],
		place: [v => !!v || 'A place is required.'],
		repeat_delay: [
			// 0 is not allowed, so !!v is suitable here
			v => !isNaN(v) && v > 0 || 'Repeat delay must be greater than 0.',
			v => !!v || 'Repeat delay is required.',
			v => !isNaN(v) || 'Repeat delay must be a number.'
		],
		repeat_delay_type: [
			v => !!v || 'Repeat delay type is required.'
		],
	}),

	shouldShowSection: (showSections, section) =>
			!showSections.length || showSections.includes(section)
};

const couponHelpers = {

	getValidationRules: (data) => ({
		template_id: [v => !!v || 'You must choose a coupon template.'],
		name: [v => !!v || 'Coupon name is required.'],
		basic: [v => !!v || 'Coupon text is required.'],
		amount_off: [
			v => !!v || 'Discount amount off is required.',
			v => v >= 1 || 'Discount amount should be at least $1.'
		],
		percent_off: [
			v => !!v || 'Discount percent off is required.',
			v => v >= 10 || 'Discount percent should be at least 10%.'
		],
		discount_item: [v => !!v || 'Discount item is required.'],
		bogo_item: [v => !!v || 'BOGO item is required.'],
		free_item: [v => !!v || 'Free item is required.'],
		purchase_item: [v => !!v || 'Purchase item is required.'],

		place: [v => !!v || 'A place is required.'],

		brief_description: [v => !!sharedHelpers.getCharacterCount(v) || 'Description is required.'],
		redemption_location: [v => !!v || 'Redemption location is required.'],
		post_redemption_instructions: [v => !!sharedHelpers.getCharacterCount(v) || 'Post redemption instructions are required.'],

		restrictions: [v => !!sharedHelpers.getCharacterCount(v) || 'Restrictions are required.'],

		// max_customer_uses: [
		// 	v => typeof v !== 'undefined' || 'Max customer uses is required.',
		// 	v => !isNaN(v) || 'Max customer uses must be a number.',
		// 	v => v !== 1 || 'One (1) usage makes this a non-repeatable coupon.'
		// ],
		// max_overall_uses: [
		// 	v => typeof v !== 'undefined' || 'Max overall uses is required.',
		// 	v => !isNaN(v) || 'Max overall uses must be a number.',
		// 	v => v !== 1 || 'One (1) usage makes this a non-repeatable coupon.'
		// ],
		repeat_delay: [
			// 0 is not allowed, so !!v is suitable here
			v => !isNaN(v) && v > 0 || 'Repeat delay must be greater than 0.',
			v => !!v || 'Repeat delay is required.',
			v => !isNaN(v) || 'Repeat delay must be a number.'
		],
		repeat_delay_type: [
			v => !!v || 'Repeat delay type is required.'
		],
		promo_code: [
			v => !!v || 'Redemption code is required.'
		],

		website: [
			v => !!v || 'Website is required.',
			v => {
				const protocolRegex = /^https?:\/\//;
				return protocolRegex.test(v) ||
						'Please include the whole website url including http(s)://'
			},
			v => {
				const fullRegex = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b[-a-zA-Z0-9()@:%_+.~#?&\/=]*$/;
				return fullRegex.test(v) || 'Website url is invalid.'
			}
		],
		phone: [
			v => !!v || 'Phone is required.',
			() => data.phoneIsValid || 'Please enter a valid phone.'
		],
		redemption_instructions: [
			v => !!sharedHelpers.getCharacterCount(v) || 'Redemption instructions are required.',
		],
	}),

	shouldShowSection: (showSections, section) =>
			!showSections.length || showSections.includes(section)

};

const admissionHelpers = {

	getValidationRules: (data) => ({
		end_date: [v => !!v || 'End date is required.'],
		name: [v => !!v || 'Name is required.'],
		short_information: [v => !!sharedHelpers.getCharacterCount(v) || 'Please specify what\'s included.'],
		retail_price: [v => !!v && v >= 0.01 || 'Retail price is required.'],
		redemption_settings_mode: [v => !!v || 'Location is required.'],
		redemption_instructions: [
			v => !!sharedHelpers.getCharacterCount(v) || 'Redemption instructions are required.',
		],
		redemption_location: [v => !!v || 'Redemption location is required.'],
		post_redemption_instructions: [v => !!sharedHelpers.getCharacterCount(v) || 'Post redemption instructions are required.'],
		website: [
			v => !!v || 'Website is required.',
			v => {
				const protocolRegex = /^https?:\/\//;
				return protocolRegex.test(v) ||
						'Please include the whole website url including http(s)://'
			},
			v => {
				const fullRegex = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b[-a-zA-Z0-9()@:%_+.~#?&\/=]*$/;
				return (!v || (!!v && fullRegex.test(v))) || 'Website url is invalid.'
			}
		],
		promo_code: [
			v => !!v || 'Redemption code is required.'
		],
		place: [v => !!v || 'A place is required.'],
		template_id: [v => !!v || 'You must choose a ticket template.'],
	}),

};

const culinaryHelpers = {

	getValidationRules: (data) => ({
		template_id: [v => !!v || 'You must choose a culinary template.'],
		name: [v => !!v || 'Name is required.'],
		title: [v => !!v || 'Menu title is required.'],
		culinary_menu: [v => !!sharedHelpers.getCharacterCount(v) || 'Menu is required.'],
		place: [v => !!v || 'A place is required.'],
		redemption_validation: [v => !!v || 'Check-in validation is required.'],
		repeat_delay: [
			v => !!v || v === 0 || 'Duration Amount is required.',
			v => !isNaN(v) && v > 0 || 'Duration Amount must be greater than 0.'
		],
		repeat_delay_type: [
			v => !!v || 'Duration type is required.'
		],
	}),

};

const tastingHelpers = {

	getValidationRules: (data) => ({
		template_id: [v => !!v || 'You must choose a tasting template.'],
		tasting_free_item: [v => !!v || 'Item name is required.'],
		special_item_name: [v => !!v || 'Item name is required.'],
		tasting_flight_type: [v => !!v || 'Type of Tasting Flight is required.'],
		tasting_voucher_amount: [
			v => !!v || 'Amount is required.',
			v => v >= 5 || 'Amount should be at least $5.'
		],
		retail_price: [v => !!v && v >= 0.01 || 'Retail price is required.'],
		included: [v => !!sharedHelpers.getCharacterCount(v) || 'This is required.'],
		redemption_settings_mode: [v => !!v || 'Location is required.'],
		redemption_instructions: [
			v => !!sharedHelpers.getCharacterCount(v) || 'Redemption instructions are required.',
		],
		post_redemption_instructions: [v => !!sharedHelpers.getCharacterCount(v) || 'Post redemption instructions are required.'],
		redemption_location: [v => !!v || 'Redemption location is required.'],
		website: [
			v => !!v || 'Website is required.',
			v => {
				const protocolRegex = /^https?:\/\//;
				return protocolRegex.test(v) ||
						'Please include the whole website url including http(s)://'
			},
			v => {
				const fullRegex = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b[-a-zA-Z0-9()@:%_+.~#?&\/=]*$/;
				return (!v || (!!v && fullRegex.test(v))) || 'Website url is invalid.'
			}
		],
		promo_code: [
			v => !!v || 'Redemption code is required.'
		],
		place: [v => !!v || 'A place is required.'],
	}),

};

const quizHelpers = {

	getValidationRules: ({ quiz: { answers, type }, secondaryValidation }) => ({
		name: [v => !!v || 'Name is required.'],
		place: [v => !!v || 'A place is required.'],
		brief_description: [v => !!sharedHelpers.getCharacterCount(v) || 'A brief description is required.'],
		type: [v => !!v || 'A quiz type is required.'],
		question: [v => !!v || 'A question is required.'],
		answer: [
			v => !!v || 'An answer is required.',
			v => !!v &&
					(type === 'single' ||
							(type === 'multiple' && answers.some(({ correct }) => correct))) ||
					'At least one correct answer is required.'
		],
		checkbox: [
			v => type === 'multiple' && answers.some(({ correct }) => correct) ||
					'At least one correct answer is required.'
		],
		radio: [
			v => type !== 'single' || !!v || v === 0 ||
					'At least one correct answer is required.'
		],
		confirmation: [v => !!v || 'Confirmation message is required.'],
		redemption: [v => !!v || 'Redemption button label is required.'],
		mobile_text: [v => !!v || 'Text on Mobile Pass button is required.'],
		repeat_delay: [
			v => !!v || v === 0 || 'Duration Amount is required.',
			v => !isNaN(v) && v > 0 || 'Duration Amount must be greater than 0.'
		],
		repeat_delay_type: [
			v => !!v || 'Duration type is required.'
		],
		radius: [
			v => secondaryValidation === '' || v >= 0.25 ||
					'You must select a radius greater than 0.25 miles.'
		],
		multipleAnswers: [
			v => {
				if(v === 'single') {
					return answers.length >= 2 || 'At least two (2) answers are required when a single answer is expected.';
				}
				if(v === 'multiple') {
					if(answers.length < 3) {
						return 'At least three (3) answers are required when multiple answers are expected.';
					}
					return answers.filter(answer => answer.correct).length >= 2 || 'At least two (2) correct answers are required when multiple answers are expected.';
				}
			}
		]
	}),

	shouldShowSection: (showSections, section) =>
			!showSections.length || showSections.includes(section)
};


export {
	checkinHelpers,
	couponHelpers,
	productHelpers,
	admissionHelpers,
	culinaryHelpers,
	tastingHelpers,
	quizHelpers
};
